import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import PhotoRespVos from './photo_list.vue';

formCreate.component('PhotoRespVos', PhotoRespVos);
export default {
  name: 'promote_employee_salaries',
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'promote_employee_form',
    };
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue(this.formConfig.row);
        if (tempData && tempData.photoRespVos && photoRespVos.length !== 0) {
          this.hiddenFields(false, ['photoRespVos', 'title2']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title2']);
        }
      }
    },
    // 校验图片
    checkPhoto(pics) {
      request.post('/sfa/sensegalaxyfilestatus/queryFileStatus', pics).then((res) => {
        console.log(res);
        if (res.success) {
          this.fApi.getRule('photoRespVos').props.checkPicList = res.result || [];
        }
      });
    },
    setRule(item) {
      const v = item;
      if (v.field === 'photoRespVos') {
        const photoList = this.formConfig.row.photoRespVos || [];
        this.checkPhoto(photoList.map((pics) => pics.fileUrl));
        v.props.value = photoList;
        v.props.checkPicList = [];
      }
      return v;
    },

  },
  created() {

  },

};
